import { Component, Input, Output, EventEmitter } from '@angular/core';

import { LayerCatalog, GroupLayers } from '../../layer';

@Component({
  selector: 'igo-catalog-layers-list',
  template: require('./catalog-layers-list.component.html'),
  styles: [require('./catalog-layers-list.component.styl')]
})
export class CatalogLayersListComponent {

  @Input()
  get groupsLayers(): GroupLayers[] { return this._groupsLayers; }
  set groupsLayers(value: GroupLayers[]) {
    this._groupsLayers = value;
  }
  private _groupsLayers: GroupLayers[];

  @Output() select = new EventEmitter<LayerCatalog>();
  @Output() unselect = new EventEmitter<LayerCatalog>();

  constructor() {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/catalog/catalog-layers-list/catalog-layers-list.component.ts